<template>
         <v-dialog
            v-model="$store.state.dialogoProductohijo"
              max-width="450px"
            >
          <v-system-bar window dark>
        <v-icon @click="$store.commit('dialogoProductohijo')">mdi-close</v-icon>
      </v-system-bar>
      <v-card
        class="mx-auto "
        color="white"
        max-width="450px"
      >
          <v-form
              ref="form"
              class="pa-3"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
                v-model="Nombre"
                :counter="8"
                :rules="Nombrerules"
                label="Nombre Producto"
                required
              ></v-text-field>
                <v-text-field
                v-model="intervalo"
                :counter="8"
                :rules="Nombrerules"
                label="intervalo"
                required
              ></v-text-field>

            <v-file-input
                label="File input"
                filled
                v-model="selectedFile"
                prepend-icon="mdi-camera"
              ></v-file-input>
         <v-btn
            
          :disabled="!valid"
            :color="$store.state.colorselecto"
            @click="$store.commit('dialogoaPaletaColores')"
          >
            Color
          </v-btn>
            </v-form>
            
        <v-card-actions>
          <v-col>
          <v-btn
            block
          :disabled="!valid"
            color="success"
            class="mr-4"
            @click.stop="agregar"
          >
            Guardar
          </v-btn>

          <v-btn
            block
          :disabled="!valid"
            color="error"
            class="mt-4"
            @click.stop="eliminar"
          >
            Eliminar
          </v-btn>

          </v-col>

         <v-dialog
            v-model="progress"
            max-width="200"
            >
            <v-card>
                 <v-progress-circular
                  :rotate="90"
                  :size="200"
                  :width="15"
                  :value="Uploadvalue"
                  color="red"
                >
                  {{ Uploadvalue }}
                </v-progress-circular>
            </v-card>

         </v-dialog>


        </v-card-actions>

      </v-card>
           <paletaColores/>
     </v-dialog>

</template>

<script>
import { db } from '../db'
import store from '@/store/index'
import paletaColores from '@/components/paletaColores'
var ref = db.database().ref("productosHijo")

  export default {
    name: 'agregaCategoria',
        components: {
        paletaColores
        },

    props:[
      'Nombre',
      'picture',
      'color',
      'intervalo',
      'linea',
      'categoria',
      'productopadre'
    ],


    data() {
        return {
        intervalo:'',
        progress: false,
        selectedFile:null,
        Uploadvalue:0,
        picture:null,
        valid: true,
        Nombre: '',
        color:'',
        Nombrerules: [
        v => !!v || 'Obligatorio',
        v => (v && v.length > 0) || 'No puede ser vacio',
      ],

        }
      },
  

      beforeDestroy () {
         clearInterval(this.interval)
      },
       methods: {

        agregar(){
                this.validate()
            if(this.Nombre!="" ){
                this.onupload()
                
            }
        },

        eliminar(){
            if(this.Nombre!="" ){
             // Create a reference to the file to delete
              var desertRef = db.storage().ref(`/imagenesproductosHijo/${this.linea+this.categoria+this.productopadre+this.Nombre.trim()}`)

              desertRef.delete().then(function() {

                console.log("exito")
              }).catch(function(error) {
                // Uh-oh, an error occurred!
                  console.log("fallo", error)
              });
              var tabla = ref.child(this.linea+this.categoria+this.productopadre+this.Nombre.trim())
              tabla.remove()
               store.commit('dialogoProductohijo')
            }
        },

        onupload(){
            if(!this.selectedFile){
            console.log("existe")
                var tabla = ref.child(this.linea+this.categoria+this.productopadre+this.Nombre.trim())
                tabla.child("color").set(store.state.colorselecto)
                tabla.child("intervalo").set(this.intervalo)
                this.Nombre='',
                this.picture='',
                this.selectedFile='',
                this.color='',
                this.intervalo=''
                store.commit('dialogoProductohijo')
          }
          else{
          this.progress = true
         const storageRef = db.storage().ref(`/imagenesproductosHijo/${this.linea+this.categoria+this.productopadre+this.Nombre.trim()}`)
         const task=storageRef.put(this.selectedFile)
         task.on('state_changed',snapshot=>{
      
           let porcentaje = (snapshot.bytesTransferred/snapshot.totalBytes)*100
           this.Uploadvalue = porcentaje
         },error=>{console.log(error.message)},
         ()=>{this.Uploadvalue=100;
              task.snapshot.ref.getDownloadURL().then((url)=>{
                this.picture = url;

                    console.log("existe")
                var tabla = ref.child(this.linea+this.categoria+this.productopadre+this.Nombre.trim())
               tabla.child("nombre").set(this.Nombre.trim())
               tabla.child("intervalo").set(this.intervalo)
               tabla.child("color").set(store.state.colorselecto)
               tabla.child("foto").set(this.picture)
               tabla.child("linea").set(this.linea)
               tabla.child("categoria").set(this.categoria)
               tabla.child("productopadre").set(this.productopadre)
                this.Nombre='',
                this.selectedFile='',
                this.intervalo=''
                this.progress = false
                store.commit('dialogoProductohijo')
                console.log(this.picture)
              })
         }
         )
         }
        },

        validate () {
            this.$refs.form.validate()
        },


      },



  }
</script>